export default {"src":"/_next/static/media/arrowUp.3837ea1e.svg","height":7,"width":14,"blurWidth":0,"blurHeight":0};